export const firebaseConfig = {
  apiKey: "AIzaSyBTYwy9t5N5mCFYRhtc38YZ1dvgY1kUKw4",
  authDomain: "nomanslan-da079.firebaseapp.com",
  projectId: "nomanslan-da079",
  storageBucket: "nomanslan-da079.firebasestorage.app",
  messagingSenderId: "541906862536",
  appId: "1:541906862536:web:fee13bb22f2e3c4ba880fd"
};